export const outreachStats = {
  totalProspects: 127,
  responseRate: 34.6,
  activeConversations: 18,
  dealsClosed: 9
};

export const prospects = [
  {
    id: '1',
    name: 'Sarah Chen',
    email: 'sarah.chen@techflow.io',
    company: 'TechFlow Solutions',
    role: 'Marketing Director',
    status: 'negotiating',
    avatar: 'https://public.readdy.ai/ai/img_res/021581248d232d849557eb595ac41822.jpg',
    website: 'https://techflow.io',
    lastContacted: '2024-01-15T14:30:00Z',
    notes: 'Interested in 15% commission structure. Follow up on contract terms next week.'
  },
  {
    id: '2',
    name: 'Marcus Johnson',
    email: 'marcus@cloudnine.com',
    company: 'CloudNine Software',
    role: 'Partnership Manager',
    status: 'replied',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20african%20american%20man%20business%20executive%20corporate%20headshot%20clean%20background&width=100&height=100&seq=outreach-avatar-2&orientation=squarish',
    website: 'https://cloudnine.com',
    lastContacted: '2024-01-14T09:15:00Z',
    notes: 'Positive response. Wants to see traffic metrics before committing.'
  },
  {
    id: '3',
    name: 'Emily Rodriguez',
    email: 'e.rodriguez@datastream.co',
    company: 'DataStream Analytics',
    role: 'Head of Partnerships',
    status: 'partner',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20hispanic%20woman%20business%20executive%20smiling%20corporate%20headshot%20clean%20background&width=100&height=100&seq=outreach-avatar-3&orientation=squarish',
    website: 'https://datastream.co',
    lastContacted: '2024-01-13T16:45:00Z',
    notes: 'Active partner since Dec 2023. 20% commission on all sales. Monthly payouts.'
  },
  {
    id: '4',
    name: 'David Kim',
    email: 'david.kim@nexusai.com',
    company: 'Nexus AI',
    role: 'Business Development',
    status: 'contacted',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20man%20business%20developer%20corporate%20headshot%20clean%20background&width=100&height=100&seq=outreach-avatar-4&orientation=squarish',
    website: 'https://nexusai.com',
    lastContacted: '2024-01-12T11:20:00Z',
    notes: 'Sent initial partnership proposal. Awaiting response.'
  },
  {
    id: '5',
    name: 'Lisa Anderson',
    email: 'lisa@innovatetech.io',
    company: 'InnovateTech',
    role: 'VP of Marketing',
    status: 'new',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20caucasian%20woman%20executive%20corporate%20headshot%20clean%20background&width=100&height=100&seq=outreach-avatar-5&orientation=squarish',
    website: 'https://innovatetech.io',
    lastContacted: '2024-01-10T08:00:00Z',
    notes: 'Found through LinkedIn. High potential SaaS product in productivity space.'
  },
  {
    id: '6',
    name: 'James Wilson',
    email: 'james.wilson@pixelpro.com',
    company: 'PixelPro Design',
    role: 'Co-Founder',
    status: 'partner',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20man%20cofounder%20startup%20entrepreneur%20corporate%20headshot%20clean%20background&width=100&height=100&seq=outreach-avatar-6&orientation=squarish',
    website: 'https://pixelpro.com',
    lastContacted: '2024-01-09T13:30:00Z',
    notes: 'Active partner. 18% commission. Great conversion rates on design tools.'
  },
  {
    id: '7',
    name: 'Priya Patel',
    email: 'priya@growthmetrics.io',
    company: 'GrowthMetrics',
    role: 'Affiliate Manager',
    status: 'negotiating',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20indian%20woman%20business%20manager%20corporate%20headshot%20clean%20background&width=100&height=100&seq=outreach-avatar-7&orientation=squarish',
    website: 'https://growthmetrics.io',
    lastContacted: '2024-01-08T15:45:00Z',
    notes: 'Discussing tiered commission structure. 12-25% based on volume.'
  },
  {
    id: '8',
    name: 'Michael Brown',
    email: 'mbrown@securecloud.net',
    company: 'SecureCloud',
    role: 'Sales Director',
    status: 'replied',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20man%20sales%20director%20corporate%20headshot%20clean%20background&width=100&height=100&seq=outreach-avatar-8&orientation=squarish',
    website: 'https://securecloud.net',
    lastContacted: '2024-01-07T10:15:00Z',
    notes: 'Interested but needs approval from legal team. Following up next week.'
  },
  {
    id: '9',
    name: 'Sofia Martinez',
    email: 'sofia@automateflow.com',
    company: 'AutomateFlow',
    role: 'Marketing Lead',
    status: 'contacted',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20woman%20marketing%20lead%20corporate%20headshot%20clean%20background&width=100&height=100&seq=outreach-avatar-9&orientation=squarish',
    website: 'https://automateflow.com',
    lastContacted: '2024-01-06T14:00:00Z',
    notes: 'Sent partnership deck. Product fits our automation category well.'
  },
  {
    id: '10',
    name: 'Alex Turner',
    email: 'alex@codebase.dev',
    company: 'CodeBase',
    role: 'Product Manager',
    status: 'new',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20person%20product%20manager%20tech%20corporate%20headshot%20clean%20background&width=100&height=100&seq=outreach-avatar-10&orientation=squarish',
    website: 'https://codebase.dev',
    lastContacted: '2024-01-05T09:30:00Z',
    notes: 'Developer tools platform. High AOV potential. Need to craft personalized pitch.'
  }
];

export const conversations = [
  {
    id: 'msg-1-1',
    prospectId: '1',
    direction: 'sent',
    subject: 'Partnership Opportunity with AFFILIX',
    body: 'Hi Sarah,\n\nI came across TechFlow Solutions and was impressed by your innovative approach to workflow automation. I run AFFILIX, a tech product discovery platform with 50K+ monthly visitors in the B2B SaaS space.\n\nI believe there\'s a great opportunity for us to partner and promote TechFlow to our engaged audience. Would you be open to discussing an affiliate partnership?\n\nLooking forward to connecting!\n\nBest regards',
    timestamp: '2024-01-10T10:00:00Z',
    read: true
  },
  {
    id: 'msg-1-2',
    prospectId: '1',
    direction: 'received',
    subject: 'Re: Partnership Opportunity with AFFILIX',
    body: 'Hi there,\n\nThanks for reaching out! We\'re definitely interested in exploring affiliate partnerships. Your platform sounds like a great fit for our target audience.\n\nCould you share more details about your commission structure and typical conversion rates?\n\nBest,\nSarah',
    timestamp: '2024-01-11T14:30:00Z',
    read: true
  },
  {
    id: 'msg-1-3',
    prospectId: '1',
    direction: 'sent',
    subject: 'Re: Partnership Opportunity with AFFILIX',
    body: 'Hi Sarah,\n\nGreat to hear you\'re interested! Here are the details:\n\n• Commission: 15-20% recurring on all sales\n• Cookie duration: 60 days\n• Average conversion rate: 3.2% for SaaS products\n• Monthly traffic: 50K+ qualified visitors\n• Dedicated product page + newsletter features\n\nWe also provide monthly performance reports and marketing materials. Would you like to schedule a quick call to discuss contract terms?\n\nBest regards',
    timestamp: '2024-01-12T09:15:00Z',
    read: true
  },
  {
    id: 'msg-1-4',
    prospectId: '1',
    direction: 'received',
    subject: 'Re: Partnership Opportunity with AFFILIX',
    body: 'This looks promising! I\'d like to review the contract terms before we proceed. Can you send over a draft agreement? I\'ll have our legal team take a look.\n\nAlso, do you have case studies from similar partnerships?\n\nThanks,\nSarah',
    timestamp: '2024-01-15T14:30:00Z',
    read: true
  },
  {
    id: 'msg-2-1',
    prospectId: '2',
    direction: 'sent',
    subject: 'Affiliate Partnership Proposal - CloudNine Software',
    body: 'Hi Marcus,\n\nI hope this email finds you well. I\'m reaching out because CloudNine Software would be a perfect addition to our affiliate platform.\n\nAFFILIX specializes in promoting premium B2B software to a highly targeted audience of tech decision-makers. We\'d love to feature CloudNine and drive qualified leads your way.\n\nInterested in exploring this opportunity?\n\nBest',
    timestamp: '2024-01-12T08:00:00Z',
    read: true
  },
  {
    id: 'msg-2-2',
    prospectId: '2',
    direction: 'received',
    subject: 'Re: Affiliate Partnership Proposal - CloudNine Software',
    body: 'Hi,\n\nThanks for the outreach. We\'re always looking for quality affiliate partners. Before we move forward, could you provide:\n\n1. Your monthly traffic breakdown by source\n2. Audience demographics\n3. Examples of other software you promote\n4. Historical conversion data\n\nLooking forward to your response.\n\nMarcus',
    timestamp: '2024-01-14T09:15:00Z',
    read: true
  },
  {
    id: 'msg-3-1',
    prospectId: '3',
    direction: 'sent',
    subject: 'Monthly Performance Report - December 2023',
    body: 'Hi Emily,\n\nHere\'s your monthly performance summary for December:\n\n• Total Clicks: 2,847\n• Conversions: 94\n• Revenue Generated: $18,800\n• Your Commission: $3,760\n\nDataStream continues to be one of our top-performing partnerships! The analytics dashboard feature is particularly popular with our audience.\n\nPayment will be processed on January 5th as usual.\n\nBest regards',
    timestamp: '2024-01-13T16:45:00Z',
    read: true
  },
  {
    id: 'msg-4-1',
    prospectId: '4',
    direction: 'sent',
    subject: 'Exciting Partnership Opportunity for Nexus AI',
    body: 'Hi David,\n\nI\'ve been following Nexus AI\'s growth and I\'m impressed by your AI-powered automation platform. I believe there\'s a strong synergy between your product and our audience at AFFILIX.\n\nWe reach 50K+ monthly visitors who are actively looking for cutting-edge AI tools. I\'d love to discuss how we can partner to bring Nexus AI to this engaged audience.\n\nWould you be available for a brief call this week?\n\nBest regards',
    timestamp: '2024-01-12T11:20:00Z',
    read: true
  },
  {
    id: 'msg-6-1',
    prospectId: '6',
    direction: 'sent',
    subject: 'January Performance Update - PixelPro',
    body: 'Hi James,\n\nQuick update on PixelPro\'s performance so far this month:\n\n• Clicks: 1,234 (↑ 23% vs last month)\n• Conversions: 67\n• Conversion Rate: 5.4% (excellent!)\n• Revenue: $10,050\n\nYour design tools are resonating really well with our creative professional segment. The new UI kit launch is driving great engagement.\n\nKeep up the great work!\n\nBest',
    timestamp: '2024-01-09T13:30:00Z',
    read: true
  },
  {
    id: 'msg-7-1',
    prospectId: '7',
    direction: 'sent',
    subject: 'Partnership Proposal - GrowthMetrics',
    body: 'Hi Priya,\n\nI came across GrowthMetrics and was impressed by your analytics platform. I run AFFILIX, a product discovery site focused on B2B SaaS tools.\n\nI\'d love to discuss an affiliate partnership. We have a strong track record with analytics tools and could drive significant qualified traffic to GrowthMetrics.\n\nAre you open to exploring a partnership?\n\nBest regards',
    timestamp: '2024-01-05T10:00:00Z',
    read: true
  },
  {
    id: 'msg-7-2',
    prospectId: '7',
    direction: 'received',
    subject: 'Re: Partnership Proposal - GrowthMetrics',
    body: 'Hi,\n\nYes, we\'re definitely interested! We have a tiered commission structure:\n\n• Tier 1: 12% (0-50 sales/month)\n• Tier 2: 18% (51-100 sales/month)\n• Tier 3: 25% (100+ sales/month)\n\nAll commissions are recurring for the lifetime of the customer. Does this work for you?\n\nPriya',
    timestamp: '2024-01-06T14:20:00Z',
    read: true
  },
  {
    id: 'msg-7-3',
    prospectId: '7',
    direction: 'sent',
    subject: 'Re: Partnership Proposal - GrowthMetrics',
    body: 'Hi Priya,\n\nThe tiered structure looks great! I\'m confident we can reach Tier 2-3 within the first few months based on our performance with similar products.\n\nA few questions:\n1. What\'s the cookie duration?\n2. Do you provide marketing materials (banners, product shots, etc.)?\n3. What\'s the typical sales cycle for your product?\n\nLooking forward to finalizing this!\n\nBest',
    timestamp: '2024-01-08T15:45:00Z',
    read: true
  },
  {
    id: 'msg-8-1',
    prospectId: '8',
    direction: 'sent',
    subject: 'Affiliate Partnership - SecureCloud',
    body: 'Hi Michael,\n\nSecureCloud\'s security solutions would be a valuable addition to our platform. We have a growing audience of IT professionals and security-conscious businesses.\n\nI\'d love to discuss how we can partner to promote SecureCloud through AFFILIX. Our typical commission structure is 15-20% with 60-day cookie duration.\n\nInterested in learning more?\n\nBest regards',
    timestamp: '2024-01-04T09:00:00Z',
    read: true
  },
  {
    id: 'msg-8-2',
    prospectId: '8',
    direction: 'received',
    subject: 'Re: Affiliate Partnership - SecureCloud',
    body: 'Hi,\n\nThanks for reaching out. This sounds interesting, but I\'ll need to run it by our legal and compliance team first given the nature of our security products.\n\nCan you send over:\n• Your standard affiliate agreement\n• Information about your vetting process for affiliates\n• Any compliance certifications\n\nI\'ll follow up once I have feedback from the team.\n\nMichael',
    timestamp: '2024-01-07T10:15:00Z',
    read: true
  }
];
